import { Links } from './assets/components/links';
import './App.css';
function App() {
  return (
    <div>
      <Links />
    </div>
  );
}

export default App;
